import type { ConversionType } from '../constants'

type OnlineBookingParams = { type: 'ONLINE_BOOKING'; bookingId: string }
type OtherParams = {
  type: Exclude<ConversionType, 'ONLINE_BOOKING'>
  bookingId?: never
}

export const generateOrderId = ({
  type,
  bookingId,
}: OnlineBookingParams | OtherParams): string => {
  if (type === 'ONLINE_BOOKING') {
    return bookingId
  }

  const prefixes: Record<Exclude<ConversionType, 'ONLINE_BOOKING'>, string> = {
    PHONE: 'phone',
    CONTACT: 'contact',
    PREBOOKING: 'prebooking',
  }

  return `${prefixes[type]}_${new Date().getTime()}`
}
